import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 16A8 8 0 108 0a8 8 0 000 16z" fill="#EC3F3F" /><path fillRule="evenodd" clipRule="evenodd" d="M5.85 5.15L8 7.29l2.15-2.14a.5.5 0 01.7.7L8.71 8l2.14 2.15a.5.5 0 01-.7.7L8 8.71l-2.15 2.14a.5.5 0 01-.7-.7L7.29 8 5.15 5.85a.5.5 0 11.7-.7z" fill="#fff" /></svg>);